"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _lib = _interopRequireDefault(require("@xto10x/storage/lib"));
var _config = _interopRequireDefault(require("./config"));
var _constants = require("./constants");
var _httpClient = _interopRequireDefault(require("./httpClient"));
var configApi = {
  getUserConfig: function getUserConfig(preferenceType) {
    var requestBody = {
      operation: 'read',
      user_email: _lib["default"].getDataFromLocal(_constants.StorageKey.USER_INFO).email,
      payload: {
        Key: {
          preference_type: preferenceType,
          user_id: _lib["default"].getDataFromLocal(_constants.StorageKey.USER_INFO).user_reference_id
        }
      }
    };
    return _httpClient["default"].post("".concat(_config["default"].userConfigDynamoInvokeUrl, "/user-preference"), requestBody);
  },
  postUserConfig: function postUserConfig(data, preferenceType) {
    var requestBody = {
      operation: 'create',
      user_email: _lib["default"].getDataFromLocal(_constants.StorageKey.USER_INFO).email,
      payload: {
        Item: {
          preference_type: preferenceType,
          user_id: _lib["default"].getDataFromLocal(_constants.StorageKey.USER_INFO).user_reference_id,
          data: data
        }
      }
    };
    return _httpClient["default"].post("".concat(_config["default"].userConfigDynamoInvokeUrl, "/user-preference"), requestBody);
  },
  getGlobalConfig: function getGlobalConfig(configType) {
    return _httpClient["default"].get("".concat(_config["default"].userConfigDynamoInvokeUrl, "/global-configs/").concat(configType));
  },
  getPublicConfig: function getPublicConfig(appName, configName) {
    return _httpClient["default"].get("".concat(_config["default"].userConfigDynamoInvokeUrl, "/public-configs?appName=").concat(appName).concat(configName ? "&configName=".concat(configName) : ''));
  }
};
var _default = exports["default"] = configApi;